// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".is-fullheight[data-v-e021c114]{height:100%}.is-absolute[data-v-e021c114]{position:absolute}.buttons-container[data-v-e021c114]{position:-webkit-sticky;position:sticky;bottom:0;display:grid;grid-template-columns:repeat(2,1fr);gap:20px}.top[data-v-e021c114]{z-index:1000}.h-3_5[data-v-e021c114]{height:3.5rem!important}.mw-9[data-v-e021c114]{min-width:9rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
